import { addToDate, subtractFromDate, today, isBetweenDates } from 'utils/date';

export const getPeriodDailySurvey = (dailySurveys) => {
  const last4Months = subtractFromDate(today, 4, 'months');
  const last6Months = subtractFromDate(today, 6, 'months');
  const last12Months = subtractFromDate(today, 12, 'months');

  const surveyForLast4Months = dailySurveys?.filter(
    (dailySurvey) =>
      dailySurvey?.latestParticipantTaskEntry &&
      isBetweenDates(
        dailySurvey?.latestParticipantTaskEntry?.createdAt,
        last4Months,
        addToDate(today, 1, 'days')
      )
  );
  const surveyForLast6Months = dailySurveys?.filter(
    (dailySurvey) =>
      dailySurvey?.latestParticipantTaskEntry &&
      isBetweenDates(
        dailySurvey?.latestParticipantTaskEntry?.createdAt,
        last6Months,
        addToDate(today, 1, 'days')
      )
  );
  const surveyForLast12Months = dailySurveys?.filter(
    (dailySurvey) =>
      dailySurvey?.latestParticipantTaskEntry &&
      isBetweenDates(
        dailySurvey?.latestParticipantTaskEntry?.createdAt,
        last12Months,
        addToDate(today, 1, 'days')
      )
  );

  const surveyForLast12MonthsIncludingToday = dailySurveys?.filter(
    (dailySurvey) =>
      dailySurvey?.latestParticipantTaskEntry &&
      isBetweenDates(
        dailySurvey?.latestParticipantTaskEntry?.createdAt,
        last12Months,
        addToDate(today, 1, 'days'),
        '(]'
      )
  );

  return {
    surveyForLast4Months,
    surveyForLast12Months,
    surveyForLast12MonthsIncludingToday,
    surveyForLast6Months,
  };
};

export const groupByDate = (dailySurveys) => {
  const surveys = dailySurveys?.reduce((surveysItem, data) => {
    const latestParticipantTaskEntry = data?.latestParticipantTaskEntry;
    const date = latestParticipantTaskEntry.createdAt.split('-');
    const year = date[0];
    const month = date[1];
    const key = `${year}-${month}`;
    if (!surveysItem[key]) {
      surveysItem[key] = [];
    }
    surveysItem[key].push({
      createdAt : data?.latestParticipantTaskEntry?.createdAt,
      data      : data?.latestParticipantTaskEntry?.data,
    });
    return surveysItem;
  }, {});

  return Object.keys(surveys ?? {})?.map((date) => {
    const splitDate = date.split('-');
    const year = splitDate[0];
    const month = splitDate[1];

    return {
      date,
      month,
      year,
      surveys : surveys[date],
    };
  });
};

const getPeriodArray = (numOfMonths) => {
  const periodArray = [];
  for (var i = numOfMonths; i > 0; i -= 1) {
    // let d = new Date(endingDate.getFullYear(), endingDate.getMonth() - i, 1);
    // months.push({ m: d.getMonth() + 1, y: d.getFullYear() });
    const getDate = subtractFromDate(today, i - 1, 'months');
    const month = (getDate.month() + 1).toString().padStart(2, '0');
    const year = getDate.year();

    periodArray.push({
      month,
      year,
      date    : `${year}-${month}`,
      surveys : [],
    });
  }

  return periodArray;
};

export const getDailySurveyCalendars = (
  dailySurveys,
  periodType,
  start,
  end
) => {
  const periodDailySurvey =
    periodType === 'Custom'
      ? getPeriodDailySurvey(dailySurveys).surveyForLast12MonthsIncludingToday
      : getPeriodDailySurvey(dailySurveys).surveyForLast12Months;
  const periodSurveys = groupByDate(periodDailySurvey);
  const last12MonthsGroup = getPeriodArray(12)
    .map((period) => {
      const findSurveyPeriod = periodSurveys.find(
        (survey) => survey.date === period.date
      );
      if (findSurveyPeriod) {
        period.surveys = findSurveyPeriod.surveys;
      }
      return period;
    })
    .reverse();

  if (periodType === 'Custom' && start && end) {
    const startDate = new Date(start);
    const startMonth = startDate.toLocaleDateString('en-US', {
      month : '2-digit',
    });
    const startYear = startDate.getFullYear();
    const endDate = new Date(end);
    const endMonth = endDate.toLocaleDateString('en-US', { month: '2-digit' });
    const endYear = endDate.getFullYear();

    const startItem = last12MonthsGroup.find((date) => {
      return date.month === startMonth && date.year === startYear;
    });
    const endItem = last12MonthsGroup.find((date) => {
      return date.month === endMonth && date.year === endYear;
    });

    const reverseLast12MonthsGroup = last12MonthsGroup.reverse();
    const startIndex = reverseLast12MonthsGroup.indexOf(startItem);
    const endIndex = reverseLast12MonthsGroup.indexOf(endItem);

    if (startIndex < endIndex) {
      return reverseLast12MonthsGroup.slice(startIndex, endIndex + 1).reverse();
    }
    if (startIndex === endIndex && startIndex >= 0 && endIndex >= 0) {
      return [reverseLast12MonthsGroup[startIndex]];
    }
    return [];
  }

  const periodSplit = periodType.split('_');
  const period = periodSplit[1];

  if (period) {
    return last12MonthsGroup.slice(0, period);
  }
  return [];
};

const getDailySurveyTaskEntries = (tasks = []) =>
  tasks.map((taskDetails) => ({
    endDate : taskDetails?.createdAt,
    entries : taskDetails?.data,
  }));

export const getHighlightedDays = (dailySurveys) => {
  const highlightedDays = {};
  getDailySurveyTaskEntries(dailySurveys).forEach((entry) => {
    const entries = entry?.entries;
    for (const key in entries) {
      const day = new Date(entry.endDate).getDate();
      highlightedDays[key] = {
        [day] : entries[key],
        ...(highlightedDays[key] || {}),
      };
    }
  });
  return highlightedDays;
};
